import script from "./FilePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FilePicker.vue?vue&type=script&setup=true&lang=js"

import "./FilePicker.vue?vue&type=style&index=0&id=77a4c1d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a4c1d8"]])

export default __exports__